import { python as pythonLanguage } from "@codemirror/lang-python";
import { EditorView } from "@uiw/react-codemirror";
import { EDITOR_SURFACE } from "../../common/editor-theme";

// Out here so their identity never changes: a new array reconfigures the running editor.
export const EDITOR_EXTENSIONS = [
  pythonLanguage(),
  EditorView.lineWrapping,
  ...EDITOR_SURFACE,
];
